var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192.97266pt",
    height: "192.97656pt",
    viewBox: "0 0 192.97266 192.97656",
    id: "svg16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs16"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g16",
    transform: "translate(-126.29297,-205.97266)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 425.4375,531.6823 V 274.88021 m -256.79688,0 V 531.6823",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 402.88021,509.1198 V 297.28125 H 191.04167 V 509.1198 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00229867,-1.98e-4 -2.081035,0.16126 -4.15916,0.640427 -6.081035,1.59876 -7.841451,2.718552 -9.44041,4.16126 l -1.28125,1.598959 -0.958333,1.921875 -0.802083,1.916666 -0.317709,2.083334 v 2.239583 l 0.317709,2.078125 0.802083,1.921875 0.958333,1.916667 1.28125,1.604166 1.598959,1.4375 1.760416,1.119792 1.921875,0.958333 2.078125,0.484375 2.08333367,0.15625 2.07812533,-0.15625 2.078125,-0.484375 1.921875,-0.958333 1.760416,-1.119792 1.598959,-1.4375 1.28125,-1.604166 0.958333,-1.916667 0.802083,-1.921875 0.317709,-2.078125 V 11.682094 L 12.481465,9.59876 11.679382,7.682094 10.721049,5.760219 9.439799,4.16126 7.84084,2.718552 6.080424,1.59876 4.158549,0.640427 2.080424,0.16126 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,287.75999,357.83999)",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 6.26e-4,0.002304 H 256.7975 m -49.75521,-70.5625 V -202.24249 M 186.24021,-49.758113 H 54.557918 M 186.24021,-70.560196 54.557918,-202.24249 M 256.7975,-256.79978 H 6.26e-4",
    transform: "matrix(0.75,0,0,0.75,126.48,398.75999)",
    id: "path4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/Душ.6ac17c28b41dde83fb66d72395a7048d.svg";
export { ForwardRef as ReactComponent };